exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidenav-overflow-y{\r\n  overflow-y:auto;\r\n}\r\n\r\n.dashboard-overflow-y{\r\n  overflow-y:auto;\r\n}\r\n\r\n.sidenav-background{\r\n  background: #2196F3;\r\n}\r\n\r\n.my-sidenav{\r\n  color:#FFF !important;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.my-link{\r\n  font-weight: 400;\r\n  text-transform: initial;\r\n}\r\n\r\n.my-link:hover{\r\n  font-weight: 500;\r\n  color:#2196F3 !important;\r\n  background-color: #FFF;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.my-progress{\r\n  background-color: #FFF;\r\n\tposition: fixed;\r\n  z-index: 9999;\r\n  top:0px;\r\n\tright: 0;\r\n  left: 0;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/principal/principal.component.css
// module id = ../../../../../src/app/components/principal/principal.component.css
// module chunks = main